import React from "react";

import { useIndependenceDayTheme } from "../../lib/useIndependenceDayTheme";
import HeroSection1 from "../New_Templates/HeroSection1/HeroSection";
import IndependenceDayPopup from "./IndependenceDayPopup";

/* ------------------------------------------------------------------------
 * The welcome popup, over the normal hero.
 *
 * HeroSection1 renders every day of the year. On the festival date it themes
 * ITSELF — badge, flag on a pole, confetti and a sheen on Explore Now, all
 * overlaid on the untouched card — so there is no hero swap here any more.
 * Off the date it renders exactly what it always did, and there is no popup
 * DOM, listeners or body style changes at all.
 *
 * IndependenceDayHero, the full-card replacement, is no longer mounted. It
 * is still in the repo: import it and return it in place of HeroSection1 to
 * go back to a replaced hero rather than an overlaid one.
 * ---------------------------------------------------------------------- */

export default function HomeHero() {
    const festive = useIndependenceDayTheme();

    return (
        <>
            {festive && <IndependenceDayPopup autoCloseSeconds={9} />}
            <HeroSection1 />
        </>
    );
}
